<mat-horizontal-stepper [linear]="true" #stepper labelPosition="bottom">
    <mat-step label="{{ step1Label }}" [completed]="false">
        <div class="step-wrap">
            <how-to (outEvent)="eventHandler($event)"></how-to>
        </div>
    </mat-step>

    <mat-step label="{{ step2Label }}" [completed]="false">
        <div class="step-wrap">
            <accept-terms [requiredDocs]="requiredDocs" (outEvent)="eventHandler($event)"> </accept-terms>
        </div>
    </mat-step>

    <mat-step *ngIf="needSignatures" label="{{ step3Label }}" [completed]="false">
        <div class="step-wrap">
            <app-signature-form
                *ngIf="showSign"
                [welcomeFormButtons]="true"
                [ids]="['signature-edit', 'initials-edit']"
                [user]="user"
                [canEdit]="canEditSignatures"
                [hideButton]="false"
                (outEvent)="eventHandler($event)"
            >
                <app-profile-notifications (outEvent)="eventHandler($event)"></app-profile-notifications>
            </app-signature-form>
        </div>
    </mat-step>
</mat-horizontal-stepper>
<app-footer></app-footer>
<first-login-signature-spinner *ngIf="isLoading" [needSignatures]="needSignatures"></first-login-signature-spinner>
